import React from 'react';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';
import { ISize } from '@/creditflowresearch/domain/vo/League/IStandings';

interface IProps {
  name: string,
  rowIndex: number,
  rowData: {
    categoryId: string,
    subCategoryId: string,
    hasAmount: boolean,
    name: string,
    size: ISize | null,
    count: number,
    rank: number | null,
    dateFrom: number,
    dateTo: number,
  },
  colSpan: number,
  cellCallback: (data) => React.ReactNode | React.JSX.Element | string,
}

const TableCell = ({
  rowData,
  ...otherProps
}: IProps) => {
  const { state: { selectedPeriod } } = useScorecardContext();
  const categoryIdIsEqual = selectedPeriod.categoryId === rowData.categoryId;
  const subCategoryIdIsEqual = selectedPeriod.subCategoryId === rowData.subCategoryId;
  const periodIsEqual = selectedPeriod.name === rowData.name;
  const isSelected = categoryIdIsEqual && subCategoryIdIsEqual && periodIsEqual;

  return (
    <BodyCell
      rowData={ {
        ...rowData,
        isSelected,
      } }
      { ...otherProps }
    />
  );
};

export default TableCell;
